import { Component, Input } from '@angular/core';
import { ToastController } from '@ionic/angular';

import { LatLng, Map, Marker, TileLayer } from 'leaflet';
import { SearchLocationService } from '../../services/search-location.service';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'html-marker',
    templateUrl: 'marker-popup.component.html',
    styleUrls: ['marker-popup.component.scss']
})
export class MarkerPopupComponent {
    // Latitude and Longitude values from this popup location
    lat: string;
    lng: string;

    baseLayerOpacity = 0.8;

    @Input() set latlng(value: LatLng) {
        this.lat = value.lat.toFixed(2);
        this.lng = value.lng.toFixed(2);
    }

    @Input() leafletMap: Map;
    @Input() popupMarker: Marker;

    constructor(
        private toastController: ToastController,
        public searchService: SearchLocationService
    ) {}

    async presentToast(header: string, color: string) {
        const toast = await this.toastController.create({
            header,
            color,
            duration: 3000
        });
        await toast.present();
    }

    pinpointLocation() {
        !environment.production && console.log(this.lat, this.lng);
    }

    goToLocation(ev: Event) {
        const value = (ev as CustomEvent).detail.value;

        if (!value) {
            return;
        }

        this.searchService.getLocationResults(value).subscribe(
            (res: any[]) => {
                if (res.length === 0) {
                    this.presentToast('No results', 'warning');
                } else {
                    const latlng = new LatLng(res[0].lat, res[0].lon);
                    this.leafletMap.panTo(latlng);
                    this.popupMarker.setLatLng(latlng);
                }
            },
            (error) => {
                this.presentToast('Search failed', 'danger');
                console.error(error);
            }
        );
    }

    changeOpacity(opacityRange) {
        this.leafletMap.eachLayer((layer: TileLayer) => {
            if (layer.options.id === 'base') {
                !environment.production && console.log(opacityRange.value);
                layer.setOpacity(opacityRange.value);
            }
        });
    }
}
